<script>
import { defineComponent } from 'vue'
import StepIndicarResponsavelAtendimento from '@/views/53/Steps/Teleconsulta/StepIndicarResponsavelAtendimento.vue'
import FuncionalidadeHeader from '@/components/FuncionalidadeHeader/FuncionalidadeHeader.vue'

export default defineComponent({
  name: 'Func53AlterarResponsavel',
  components: { FuncionalidadeHeader, StepIndicarResponsavelAtendimento },
  data () {
    return {}
  },
  computed: {
    consulta () {
      return this.$route.query.consulta
    },
    idMeeting () {
      return this.consulta.meeting.idMeeting
    },
    idAgenda () {
      return this.consulta.idAgenda
    },
    contrato () {
      return this.consulta.paciente.numeroContrato
    }
  },
  methods: {
    gotoDetalhesConsulta () {
      this.$router.push({ path: '/53/detalhe', query: { consulta: this.consulta } })
    }
  }
})
</script>

<template>
<div id="func-53">
  <funcionalidade-header titulo="Alterar responsável do atendimento" :customVoltar="true" @click="gotoDetalhesConsulta"></funcionalidade-header>
  <el-row>
    <el-col :span="14">
      <StepIndicarResponsavelAtendimento :id-meeting="idMeeting" :id-agenda="idAgenda" :numero-contrato="contrato" @changed="gotoDetalhesConsulta" />
    </el-col>
    <el-col :span="10">
      <div class="line"></div>
    </el-col>
  </el-row>
</div>
</template>

<style scoped>

</style>
